export const LicenseType = {
    Web: 1,
    PDA: 2
}